import { render, staticRenderFns } from "./ThreadDetails.vue?vue&type=template&id=25adb49f"
import script from "./ThreadDetails.vue?vue&type=script&lang=ts"
export * from "./ThreadDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports